import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {Signal} from '@models/dashboard/signal';
import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';
import {ChartsHelperService} from '@services/charts/helper/charts-helper.service';

@Component({
    selector: 'scitis-bar-widget-signal-item',
    templateUrl: './bar-widget-signal-item.component.html',
    styleUrls: ['./bar-widget-signal-item.component.scss'],
    standalone: false
})
export class BarWidgetSignalItemComponent {

  constructor(private chartsHelperService:ChartsHelperService) {
  }

  @Input()
  signal: ChartSignalEntry = new ChartSignalEntry();

  @Input()
  isSelectedSignal: boolean | undefined = false;

  @Input()
  signalHasBeenDeleted: boolean = false;

  @Output()
  signalStartEditEvent: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  signalDeleteEvent: EventEmitter<number> = new EventEmitter<number>();

  widgetType: UserDefinedWidgetType = UserDefinedWidgetType.BAR;


  getSignalUnit(signal: Signal | ChartSignalEntry) {
   return this.chartsHelperService.getSignalUnit(signal);
  }


  onSignalStartEdit() {
    this.isSelectedSignal = true;
    this.signalStartEditEvent.emit(this.signal.signalId);
  }

  onSignalRemove(signalId: number) {
    this.signalDeleteEvent.emit(signalId);
  }
}
